import React from "react";
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            Copyright &#169; 2025 Justin. All right received.
        </footer>
    );
}

export default Footer